import { render, staticRenderFns } from "./Recommendations.html?vue&type=template&id=025894ff&scoped=true&external"
import script from "./Recommendations.vue?vue&type=script&lang=js"
export * from "./Recommendations.vue?vue&type=script&lang=js"
import style0 from "./Recommendations.scss?vue&type=style&index=0&id=025894ff&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025894ff",
  null
  
)

export default component.exports